import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
    cvTitle: {
      fontSize:'11',
      fontFamily:'Helvetica-Bold',
    },
    cvSubtitle: {
      fontSize: 11,
      marginTop: 12,
    },
    cvInfo: {
      fontSize: 16,
      marginTop: 12,
    },
    cvOtherInfo: {
      fontSize: 11,
      marginTop: 11,
      lineHeight: 1.5
    },
    
    cvFooter:{
        marginTop: 40,
        fontSize: 14,
    },
  
    cvTableHeader:{
      marginTop: 15,
      borderBottom:'1 solid black',
      display:'flex',
      flexDirection: 'row',
      justifyContent:'space-between'
    },
    
    cvTableItem:{
      display:'flex',
      flexDirection: 'row',
      justifyContent:'space-between'
    },
    
    
    cvTblHeader1:{
        fontSize: 11,
        minWidth:'10',
        maxWidth:'10',
    },
    cvTblHeader1Bold:{
      fontSize: 11,
      minWidth:'10',
      maxWidth:'10',
      fontFamily:'Helvetica-Bold',
  },
    cvTblHeader2:{
      fontSize: 11,
        minWidth:'120',
        maxWidth:'120',
    },
    cvTblHeader2Bold:{
      fontSize: 11,
      minWidth:'120',
      maxWidth:'120',
      fontFamily:'Helvetica-Bold',
  },
    cvTblHeader3:{
      fontSize: 11,
        minWidth:'110',
        maxWidth:'110',
    },
    cvTblHeader4:{
      fontSize: 11,
        minWidth:'85',
        maxWidth:'85',
    },
  cvTblHeader3Bold:{
    fontSize: 11,
      minWidth:'110',
      maxWidth:'110',
      fontFamily:'Helvetica-Bold',
  },
  cvTblHeader4Bold:{
    fontSize: 11,
      minWidth:'85',
      maxWidth:'85',
      fontFamily:'Helvetica-Bold',
  },

    cvTblItem1:{
        fontSize: 10,
        minWidth:'10',
        maxWidth:'10',
    },
    cvTblItem2:{
        fontSize: 10,
        minWidth:'120',
       maxWidth:'120',
      alignItems:"flex-start",
    },
    cvTblItem3:{
      fontSize: 10,
        minWidth:'110',
        maxWidth:'110',
      alignItems:"flex-start",
    },
    
    cvTblItem4:{
        fontSize: 10,
        minWidth:'85',
        maxWidth:'85',
      alignItems:"flex-end",
    }, 
    
    
    body: {
      paddingTop: 35,
      paddingBottom: 65,
      paddingHorizontal: 35,
      fontFamily:'Helvetica',
    },
  
    pageNumber: {
      position: 'absolute',
      fontSize: 10,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },

    tableInfo: {
      fontSize: 10,
      marginTop: '25px',
	  marginBottom: '-5px',
    },
  });

  export function CollectionViewPdf(props) {
    const {cvDetails, allocations, payment, drpayno} = props;
      return (
        <Document>
        <Page size="A4" style={styles.body}>
          <View style={styles.cvTitle}>
            <Text>{"Collection #"+drpayno}</Text>
          </View>
          <View style={styles.cvOtherInfo}>
            <Text>Collected From: {cvDetails.collected_from}</Text>
            <Text>Branch: {cvDetails.branch}</Text>
            <Text>Contact No: {cvDetails.contact_no}</Text>
            <Text>Address: {cvDetails.address}</Text>
            <Text>Total: {cvDetails.total}</Text>
          </View>
          
           {/* allocations table use array.map */}     
           <Text style={styles.tableInfo}>Allocations</Text>
           <View style={styles.cvTableHeader}>
            <Text style={styles.cvTblHeader1Bold}>Date</Text>
            <Text style={styles.cvTblHeader2Bold}>Reference</Text>
            <Text style={styles.cvTblHeader4Bold}>Amount</Text>
           </View>      
  
          {allocations ? (allocations.map((item)=>{
            return(
              <View style={styles.cvTableItem}>
              <View style={styles.cvTblItem1}>  
                   <Text style={styles.item1}>{item.date}</Text>
              </View>
              <View style={styles.cvTblItem2}>  
                   <Text style={styles.item2}>{item.reference}</Text>
              </View>
              <View style={styles.cvTblItem4}>  
                   <Text style={styles.item4}>{item.amount}</Text>
              </View>
             </View>
            )
          }))
          : (<></>)
          }
  
  
  
           {/* payment table */}
           <Text style={styles.tableInfo}>Payments</Text>
           <View style={styles.cvTableHeader}>
            <Text style={styles.cvTblHeader1Bold}>ID</Text>
            <Text style={styles.cvTblHeader2Bold}>Payment Type</Text>
            <Text style={styles.cvTblHeader3Bold}>Reference</Text>
            <Text style={styles.cvTblHeader4Bold}>Amount</Text>
           </View>    
  
  
          <View style={styles.cvTableItem}>
            <View style={styles.cvTblItem1}>  
                 <Text style={styles.item1}>{payment[0].id}</Text>
            </View>
            <View style={styles.cvTblItem2}>  
                 <Text style={styles.item2}>{payment[0].payment_type}</Text>
            </View>
            <View style={styles.cvTblItem3}>  
                 <Text style={styles.item3}>{payment[0].reference}</Text>
            </View>
            <View style={styles.cvTblItem4}>  
                 <Text style={styles.item4}>{payment[0].amount}</Text>
            </View>
           </View>
        </Page>
      </Document>
       );
  }; 
   